import { types } from 'mobx-state-tree'

export const AppConfig = types
  .model('AppConfig', {
    isMenuOpen: types.optional(types.boolean, false),
    drawerState: types.optional(types.string, ''),
  })
  .actions((self) => {
    return {
      toggleMenu(newState) {
        self.isMenuOpen = newState ?? false
      },
      toggleDrawer(newState) {
        self.drawerState = newState ?? ''
      },
    }
  })
